<script lang="ts" setup>
import InputNumber, { type InputNumberEmits, type InputNumberProps } from 'primevue/inputnumber'

interface Props extends /* @vue-ignore */ Omit<InputNumberProps, 'size' | 'fluid'> {
  error?: boolean
  formatForCurrency?: boolean
}
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ InputNumberEmits {}
const props = defineProps<Props>()
defineEmits<Emits>()

const model = defineModel<Props['modelValue'] | null>()

const errorInjected = inject<Ref<boolean>>('error', ref(false))

const locale = computed(() => {
  if (props.formatForCurrency) {
    return 'en-US'
  }
  return undefined
})
</script>

<template>
  <InputNumber
    v-bind="$props"
    v-model="model"
    :locale
    fluid
    :size="$viewport.isLessThan('md') ? 'small' : undefined"
    :invalid="errorInjected || error"
  />
</template>
